import Axios from 'axios'
import Config from '@/Config'
import FetcherHelper from '@/helpers/FetcherHelper'

class Auth {
  static get apiBaseUrl () {
    return `${Config.authBaseUrl}/login`
  }

  static login (login, password) {
    return new Promise((resolve, reject) => {
      Axios.post(Auth.apiBaseUrl, {
        login: login,
        password: password
      }, FetcherHelper.getHeaders()).then(response => {
        if (response.status === 200) return resolve(response.data.token)
        return reject(response)
      }).catch(reject)
    })
  }
}

export default Auth
